import { cloneDeep } from 'lodash'

function pastePlaylistData(data, copyBuffer, playlistId, pasteIndex) {
  const newData = cloneDeep(data)
  const groupMap = {}

  newData.data = [
    ...newData.data.slice(0, pasteIndex),
    ...copyBuffer.map((item) => {
      let newItem = { ...item }
      const type = item.id.slice(0, 1)
      const parentType = item.parent.slice(0, 1)
      if (type === 'g') {
        const nextId = newData.groupId + 1
        newData.groupId = nextId
        newItem.id = `g${nextId}`
        groupMap[item.id] = newItem.id
      }
      if (type === 't') {
        const nextId = newData.trackId + 1
        newData.trackId = nextId
        newItem.id = `t${nextId}`
        if (newItem?.data?.selected) {
          newItem.data = {
            ...newItem.data,
            selected: false,
          }
          newItem.data.selected = false
        }
      }

      if (parentType === 'p') {
        newItem.parent = playlistId
      }

      if (parentType === 'g') {
        if (!!copyBuffer.find((check) => check.id === item.parent)) {
          newItem.parent = groupMap[item.parent]
        } else {
          newItem.parent = playlistId
        }
      }
      return newItem
    }),
    ...newData.data.slice(pasteIndex),
  ]

  return newData
}

export default pastePlaylistData
